import { setDefaultOptions } from 'date-fns'
import { es } from 'date-fns/locale'

setDefaultOptions({ locale: es })
